module.exports = __webpack_public_path__ + "img/4e7e96eb-96c3-4f18-a6fc-607819c2b753.1825e815.webp";